import { jsx } from 'react/jsx-runtime';
import { Text } from '../../components/Text/text.js';

const AssistantMessage = props => {
  const {
    text,
    chunkIndex,
    index
  } = props;
  return jsx("div", {
    className: "llm__row",
    children: jsx("div", {
      className: "llm__col --sm-10 --sm-9 --md-8 --lg-7 --xl-6",
      children: jsx(Text, {
        body: text,
        chunkIndex: chunkIndex,
        index: index
      })
    })
  });
};

export { AssistantMessage };
//# sourceMappingURL=assistant-message.js.map
